import Overview from './Overview'
import CreateView from './Create'
import TaskDetailsView from './TaskDetailsView'
import ProjectDetailsView from './ProjectDetailsView'

export default [Overview, CreateView, TaskDetailsView, ProjectDetailsView]
